import { defineNuxtPlugin, useHead, useRuntimeConfig } from '#app'
import { useCountryConfig } from '~/composables/useCountryConfig'

export default defineNuxtPlugin(() => {
  const { googleAdsenseId } = useCountryConfig()
  const { googleAdsenseEnabled } = useRuntimeConfig().public
  if (googleAdsenseEnabled)
    useHead(
      {
        meta: [
          { property: 'google-adsense-account', content: googleAdsenseId },
        ],
        script: [
          { src: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js' },
        ],
      },
      { tagPriority: 'high' },
    )
  else
    globalThis.googletag = {
      pubads: () => ({ enaableSingleRequest: () => {} }) as any,
      companionAds: () => undefined as any,
      getVersion: () => undefined as any,
      defineSlot: () => undefined as any,
      defineOutOfPageSlot: () => undefined as any,
      display: () => undefined as any,
      enableServices: () => undefined as any,
      disablePublisherConsole: () => undefined as any,
      destroySlots: () => undefined as any,
      sizeMapping: () => undefined as any,
      openConsole: () => undefined as any,
      setAdIframeTitle: () => undefined as any,
      setConfig: () => undefined as any,
      cmd: {} as any,
      secureSignalProviders: {} as any,
      apiReady: false,
      pubadsReady: false,
      enums: {} as any,
    }
})
